import { render, staticRenderFns } from "./tique.vue?vue&type=template&id=0e5c0b9e&"
import script from "./tique.vue?vue&type=script&lang=js&"
export * from "./tique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports